import { Component } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

class Boundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("UI error:", error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="bg-card border border-border rounded-sm p-6 max-w-lg">
        <div className="font-display font-bold mb-1">Ocurrió un problema al mostrar esta sección</div>
        <p className="text-sm text-muted-foreground mb-4">Tus datos están a salvo. Recarga la sección para continuar.</p>
        <Button data-testid="error-boundary-retry" className="rounded-sm" onClick={() => window.location.reload()}>Recargar</Button>
      </div>
    );
  }
}

export default function ErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <Boundary key={pathname}>{children}</Boundary>;
}
